
import { AdaptiveAlertDialog } from '@/components/ui/AdaptiveAlertDialog';
import React from 'react';

interface DeleteRecipeDialogProps {
  isOpen: boolean;
  isDeleting: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirmDelete: () => void;
}

const DeleteRecipeDialog = ({ isOpen, isDeleting, onOpenChange, onConfirmDelete }: DeleteRecipeDialogProps) => {
  return (
    <AdaptiveAlertDialog
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title="Are you sure?"
      description="This action cannot be undone. This will permanently delete the recipe from your collection."
      confirmText={isDeleting ? "Deleting..." : "Delete"}
      onConfirm={onConfirmDelete}
      isLoading={isDeleting}
      isDestructive={true}
    />
  );
};

export default DeleteRecipeDialog;
